import { type FunctionComponent } from 'react';
import { MAX_PAGE_WIDTH } from '../../../../constants/breakpoints';
import { ACCOUNT_LOGIN_LINK, PROJECT_TOOL_LINK } from '../../../../constants/links';
import { HEADER_DESCRIPTION, HERO_DESKTOP_PUBLIC_ID, HERO_MOBILE_PUBLIC_ID } from '../../../../constants/project/about-page';
import { useCustomer } from '../../../../hooks/apollo/customer/customer.hooks';
import { useEmployee } from '../../../../hooks/apollo/employee/employee.hooks';
import { Link } from '../../../common-components/link/link.component';
import { CloudinaryImage } from '../../../images/cloudinary-image/cloudinary-image.component';
import { GetStartedButton } from '../get-started-button/get-started-button.component';
import { ProjectsTourButton } from '../projects-tour-button/projects-tour-button.component';

const Heading: FunctionComponent = () => (
	<div>
		<h2 className="dib f2 f1-l font-medium mb0">
			Your <br />
			Project Planner
			<div className="theme-secondary bw1 bb mv2" style={{ width: 256 }} />
		</h2>
	</div>
);

const LogInMessage: FunctionComponent = () => {
	const { hasAccount } = useCustomer();
	const { employee } = useEmployee();
	const isInternal = employee.isAuthenticated;

	const showMessage = isInternal || !hasAccount;

	return showMessage ? (
		<p className="f5 mt1">
			Looking for your Projects?{' '}
			<Link url={`${ACCOUNT_LOGIN_LINK}?returnto=${PROJECT_TOOL_LINK}`} underline={true}>
				Log in
			</Link>
		</p>
	) : null;
};

export const AboutPageHeader: FunctionComponent = () => (
	<section className="flex flex-column mt3 mt5-ns mb5 mb0-ns ph3-m" style={{ maxWidth: MAX_PAGE_WIDTH }}>
		{/* Desktop View */}
		<div className="dn flex-ns flex-row justify-center gc3">
			<div className="flex flex-column justify-center">
				<Heading />
				<p className="theme-grey-dark f4 mt2 mb4" style={{ maxWidth: 360 }}>
					{HEADER_DESCRIPTION}
				</p>
				<div className="flex gc3">
					<GetStartedButton />
					<ProjectsTourButton />
				</div>
				<LogInMessage />
			</div>
			<div className="flex items-center w-60">
				<CloudinaryImage
					publicID={HERO_DESKTOP_PUBLIC_ID}
					options={{ crop: 'fill' }}
					description="The Project Tool"
					bypassLazyLoad={true}
				/>
			</div>
		</div>
		{/* Mobile View */}
		<div className="dn-ns flex flex-column ph3">
			<div className="flex flex-column justify-center gr5">
				<Heading />
				<div className="flex items-center w-100 ph3">
					<CloudinaryImage
						publicID={HERO_MOBILE_PUBLIC_ID}
						options={{ crop: 'fill' }}
						useDimensions={false}
						className="w-100"
						description="The Project Tool"
						bypassLazyLoad={true}
					/>
				</div>
				<div>
					<p className="f4 lh-copy mt2 mb3">{HEADER_DESCRIPTION}</p>
					<div className="w-100 mb3">
						<GetStartedButton />
					</div>
					<div className="w-100">
						<ProjectsTourButton />
					</div>
					<LogInMessage />
				</div>
			</div>
		</div>
	</section>
);
